const colors = {
  gold: '#E19E39',
  darkBlue: '#0A0E44',
  darkerBlue: '#070b43'
}
export default colors;